<div class="staff-shell p-2 p-lg-2">
  <div class="staff-panel">
    <div class="staff-header">
      <div class="d-flex align-items-center gap-2">
        <span class="title-icon">
          <lucide-icon [img]="ClipboardListIcon" [size]="16"></lucide-icon>
        </span>
        <h1 class="m-0">Staff List</h1>
      </div>

      <div class="header-tools">
        <div class="control-wrap">
          <label>Role</label>
          <select class="form-select" [value]="roleFilter()" (change)="onRoleChange(($any($event.target).value || '').toString())">
            @for (role of roleOptions(); track role) {
              <option [value]="role">{{ role === 'all' ? 'All Roles' : formatRole(role) }}</option>
            }
          </select>
        </div>

        <div class="search-wrap">
          <input class="form-control" placeholder="Search staff" [value]="search()" (input)="onSearch(($any($event.target).value || '').toString())" />
          <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
        </div>

        <button class="btn btn-primary add-btn" type="button" (click)="openAddForm()">
          <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
          <span>ADD</span>
        </button>
      </div>
    </div>

    @if (pageError()) {
      <div class="banner-error">{{ pageError() }}</div>
    }

    <div class="table-wrap">
      <div class="table-responsive">
        <table class="table mb-0 staff-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Reporting Manager</th>
              <th>Status</th>
              <th>Created</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @if (loading()) {
              <tr>
                <td colspan="9" class="text-center py-5 text-muted">Loading staff records...</td>
              </tr>
            } @else if (filteredRows().length === 0) {
              <tr>
                <td colspan="9" class="text-center py-5 text-muted">No staff records found.</td>
              </tr>
            }

            @for (row of filteredRows(); track row.id; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>
                  <div class="name-cell">
                    <span class="avatar">{{ row.full_name.slice(0, 1).toUpperCase() }}</span>
                    <span>{{ row.full_name }}</span>
                  </div>
                </td>
                <td>{{ row.username }}</td>
                <td>{{ row.email }}</td>
                <td>{{ formatRole(row.role) }}</td>
                <td>{{ reportingManagerName(row) }}</td>
                <td>
                  @if (row.active) {
                    <span class="status-chip status-active">
                      <lucide-icon [img]="CircleCheckIcon" [size]="16"></lucide-icon>
                      Active
                    </span>
                  } @else {
                    <span class="status-chip status-inactive">
                      <lucide-icon [img]="CircleXIcon" [size]="16"></lucide-icon>
                      Inactive
                    </span>
                  }
                </td>
                <td>{{ formatDate(row.created_at) }}</td>
                <td>
                  <div class="action-list">
                    <button class="action-btn view" type="button" title="View" (click)="openProfile(row)"><lucide-icon [img]="EyeIcon" [size]="14"></lucide-icon></button>
                    <button class="action-btn edit" type="button" title="Edit" (click)="openEditForm(row)"><lucide-icon [img]="PencilIcon" [size]="14"></lucide-icon></button>
                    <button class="action-btn privilege" type="button" title="Privileges" (click)="openPrivileges(row)">
                      <lucide-icon [img]="ShieldCheckIcon" [size]="14"></lucide-icon>
                    </button>
                    <button class="action-btn access" type="button" title="Regenerate Password" (click)="requestRegeneratePassword(row)">
                      <lucide-icon [img]="RotateCwIcon" [size]="14"></lucide-icon>
                    </button>
                    <button class="action-btn delete" type="button" title="Delete" (click)="deleteStaff(row)"><lucide-icon [img]="Trash2Icon" [size]="14"></lucide-icon></button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

@if (showProfile() && selectedStaff(); as profile) {
  <div class="staff-modal-backdrop">
    <div class="profile-modal">
      <div class="staff-modal-header">
        <h2 class="m-0">Profile</h2>
        <button type="button" class="close-btn" (click)="closeProfile()">x</button>
      </div>
      <div class="profile-body profile-body-simple">
        <div class="profile-avatar-wrap">
          <div class="profile-avatar-circle">
            <span>{{ profile.full_name.slice(0, 1).toUpperCase() }}</span>
          </div>
        </div>

        <div class="profile-table-wrap">
          <table class="table mb-0 profile-table">
            <tbody>
              <tr>
                <th>Name</th>
                <td>{{ profile.full_name }}</td>
              </tr>
              <tr>
                <th>Username</th>
                <td>{{ profile.username }}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{ profile.email }}</td>
              </tr>
              <tr>
                <th>Role</th>
                <td>{{ formatRole(profile.role) }}</td>
              </tr>
              <tr>
                <th>Reporting Manager</th>
                <td>{{ reportingManagerName(profile) }}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{{ profile.active ? 'Active' : 'Inactive' }}</td>
              </tr>
              <tr>
                <th>Created</th>
                <td>{{ formatDate(profile.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
}

@if (showAddForm()) {
  <div class="staff-modal-backdrop">
    <div class="staff-modal">
      <div class="staff-modal-header">
        <h2 class="m-0">{{ editingStaffId() ? 'Edit Staff' : 'Add New Staff' }}</h2>
        <button type="button" class="close-btn" (click)="closeAddForm()">x</button>
      </div>

      <div class="staff-modal-body">
        <div class="form-grid">
          <div class="field-wrap">
            <label>User Name <span>*</span></label>
            <input
              class="form-control"
              placeholder="Enter user name"
              [value]="addStaffForm().username"
              [disabled]="!!editingStaffId()"
              (input)="setFormField('username', ($any($event.target).value || '').toString())"
            />
          </div>

          <div class="field-wrap">
            <label>Full Name <span>*</span></label>
            <input
              class="form-control"
              placeholder="Enter full name"
              [value]="addStaffForm().fullName"
              (input)="setFormField('fullName', ($any($event.target).value || '').toString())"
            />
          </div>

          <div class="field-wrap">
            <label>Email ID <span>*</span></label>
            <input
              class="form-control"
              placeholder="Enter Email Id"
              [value]="addStaffForm().email"
              (input)="setFormField('email', ($any($event.target).value || '').toString())"
            />
          </div>

          <div class="field-wrap">
            <label>Reporting Manager</label>
            <select class="form-select" [value]="addStaffForm().rmId" (change)="setFormField('rmId', ($any($event.target).value || '').toString())">
              <option value="">Select RM</option>
              @for (rm of rmOptions(); track rm.id) {
                @if (rm.id !== editingStaffId()) {
                  <option [value]="rm.id">{{ rm.name }}</option>
                }
              }
            </select>
          </div>

          @if (!editingStaffId()) {
            <div class="field-wrap">
              <label>Password <span>*</span></label>
              <input
                class="form-control"
                type="password"
                placeholder="Enter password"
                [value]="addStaffForm().password"
                (input)="setFormField('password', ($any($event.target).value || '').toString())"
              />
            </div>
          }

          <div class="field-wrap role-row">
            <div>
              <label>Role <span>*</span></label>
              <div class="role-switch compact-switch">
                @for (role of staffRoleOptions; track role) {
                  <button type="button" class="role-btn" [class.active]="addStaffForm().role === role" (click)="setFormField('role', role)">
                    {{ formatRole(role) }}
                  </button>
                }
              </div>
            </div>

            <div class="checkbox-field">
              <label class="checkbox-row">
                <input type="checkbox" [checked]="addStaffForm().active" (change)="setFormField('active', !!$any($event.target).checked)" />
                <span>Active User</span>
              </label>
            </div>
          </div>
        </div>

        @if (formError()) {
          <div class="form-error">{{ formError() }}</div>
        }

        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="btn btn-primary submit-btn" [disabled]="saving()" (click)="saveStaff()">
            {{ saving() ? 'SAVING...' : editingStaffId() ? 'UPDATE' : 'ADD' }}
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (showDeleteConfirm() && deleteTarget(); as target) {
  <div class="staff-modal-backdrop">
    <div class="confirm-modal">
      <div class="confirm-body">
        <h3 class="m-0">Delete Staff</h3>
        <p class="mb-0 mt-2">Are you sure you want to delete <strong>{{ target.full_name }}</strong>?</p>
      </div>
      <div class="confirm-actions">
        <button type="button" class="btn btn-light" (click)="cancelDelete()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
      </div>
    </div>
  </div>
}

@if (showRegenerateConfirm() && regenerateTarget(); as target) {
  <div class="staff-modal-backdrop">
    <div class="confirm-modal">
      <div class="confirm-body">
        <h3 class="m-0">Regenerate Password</h3>
        <p class="mb-0 mt-2">Generate a new password for <strong>{{ target.username }}</strong>?</p>
      </div>
      <div class="confirm-actions">
        <button type="button" class="btn btn-light" (click)="cancelRegeneratePassword()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmRegeneratePassword()">Regenerate</button>
      </div>
    </div>
  </div>
}

@if (showGeneratedPassword()) {
  <div class="staff-modal-backdrop">
    <div class="password-result-modal">
      <div class="confirm-body">
        <h3 class="m-0">New Password Generated</h3>
        <p class="mb-2 mt-2">
          Username:
          <strong>{{ generatedForUser() }}</strong>
        </p>
        <div class="password-box">{{ generatedPassword() }}</div>
        @if (copyMessage()) {
          <div class="copy-message mt-2">{{ copyMessage() }}</div>
        }
      </div>
      <div class="confirm-actions">
        <button type="button" class="btn btn-light" (click)="closeGeneratedPassword()">Close</button>
        <button type="button" class="btn btn-primary" (click)="copyGeneratedPassword()">Copy Password</button>
      </div>
    </div>
  </div>
}
